export class EditConstants {

    public static DELIMITER: string = '~~';
    public static TAG: string = 'edit-component';
    public static EDIT_COMPONENT: any =  {
        ADD: {
            componentClass: '',
            package: '@pershing/pershing-page-edit-library',
            moduleName: 'EditLibraryComponentModule',
            selector: 'add-component'
        },
        EDIT: {
            componentClass: '',
            package: '@pershing/pershing-page-edit-library',
            moduleName: 'EditLibraryComponentModule',
            selector: 'edit-component'
        }
    };

}

export class EditEvent {
    // Page Assembly Actions
    public static readonly CONTENT_PLACED: string = 'pershing.assembly.content.placed';
    public static readonly LAYOUT_SELECTION_DIALOG: string = 'pershing.assembly.edit.ChangeLayoutDialog';
    public static readonly LOAD_EDIT_MODE: string = 'pershing.assembly.edit.LoadEditMode';
    public static readonly STOP_EDIT_MODE: string = 'pershing.assembly.edit.StopEditMode';
    public static readonly CHANGE_LAYOUT: string = 'pershing.assembly.edit.ChangeLayout';
    public static readonly ADD_COMPONENT: string = 'pershing.assembly.edit.AddComponent';
    public static readonly EDIT_COMPONENT: string = 'pershing.assembly.edit.EditComponent';
    public static readonly EDIT_COMPONENT_COMPLETE: string = 'pershing.assembly.edit.EditComponentCompleted';
    public static readonly REMOVE_COMPONENT: string = 'pershing.assembly.edit.RemoveComponent';
    public static readonly RELOCATE_COMPONENT: string = 'pershing.assembly.edit.RelocateComponent';
    public static readonly UPDATE_COMPONENT_INPUT: string = 'pershing.assembly.edit.UpdateComponentInputs';
    public static readonly TRIGGER_PAGE_REFRESH: string = 'pershing.assembly.edit.changeDevice';
}

export class SiteBuilderActions {
    public static readonly EDIT_LAYOUT: string = 'sitebuilder.edit.layout';
    public static readonly EDIT_PROPERTY: string = 'sitebuilder.edit.property';
    public static readonly EDIT_STYLE: string = 'sitebuilder.edit.style';
    public static readonly PAGE_CSS: string = 'sitebuilder.edit.request.pageCSS';
    public static readonly DEFAULT_CSS: string = 'pershing.assembly.page.defaultCSS';
    public static readonly UPDATE_MODES: string = 'pershing.sitebuilder.edit.UpdateModes';
    public static readonly REMOVE_STYLE: string = 'sitebuilder.remove.style';
    public static readonly UPDATE_EDIT_ACTIONS: string = 'sitebuilder.update.edit.actions';
    public static readonly CHANGE_DEVICE_TYPE: string = 'sitebuilder.update.edit.changeDevice';
}
